import type {
	CompositeFilterDescriptor,
	SortDescriptor,
} from "@tql/ui-components-react/kendo/data-query";

export const initialGridFilter: CompositeFilterDescriptor = {
	logic: "and",
	filters: [],
};

export const initialGridSort: SortDescriptor[] = [];
